import React from 'react';
import { isItSocialCompany } from '../WatchlistHelpers';

export default function WordStatus(props) {
  return isItSocialCompany(props?.data?.flag) ? <span style={{ fontSize: 16 }}>𝕏</span> : null;
}
